import styled from "styled-components";

// The app shell gives a page a fixed-height area and no scrollbar of its
// own (Matthew, 2026-11-02: "It doesn't seem to scroll"), so the page is
// its own scroll container, like the Partners page.
export const Page = styled.div`
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 24px 32px 48px;
`;

export const Inner = styled.div`
  max-width: 1280px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  font-size: 22px;
  font-weight: 600;
  margin: 0;
  color: #1f2937;
`;

export const Subtitle = styled.p`
  margin: 6px 0 20px;
  color: #6b7280;
  font-size: 14px;
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 24px;
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const FirmList = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
`;

export const FirmItem = styled.button`
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 14px;
  border: 0;
  border-bottom: 1px solid #f1f5f9;
  background: ${(p) => (p.$selected ? "#eff6ff" : "#fff")};
  cursor: pointer;

  &:hover {
    background: ${(p) => (p.$selected ? "#eff6ff" : "#f8fafc")};
  }
  &:last-child {
    border-bottom: 0;
  }
`;

export const FirmName = styled.div`
  font-weight: 600;
  color: ${(p) => (p.$inactive ? "#9ca3af" : "#111827")};
  font-size: 14px;
`;

export const FirmMeta = styled.div`
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
`;

export const Detail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Section = styled.section`
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  padding: 18px 20px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;

  h2 {
    font-size: 15px;
    font-weight: 600;
    margin: 0;
    color: #111827;
  }
`;

export const Field = styled.label`
  display: block;
  margin-bottom: 14px;

  span.label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;
  }
  span.help {
    display: block;
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
`;

export const Muted = styled.span`
  color: #6b7280;
  font-size: 13px;
`;

export const Empty = styled.div`
  padding: 28px 16px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
`;

export const ErrorBanner = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 14px;
`;

export const Notice = styled.div`
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 14px;
`;

export const Pill = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  background: ${(p) => p.$bg || "#f3f4f6"};
  color: ${(p) => p.$fg || "#374151"};
`;
